import { Component, OnInit, Input, HostListener, ViewChild } from '@angular/core';
import { FormArray, ReactiveFormsModule, FormsModule, Validators } from '@angular/forms';
import { ApprovalsService, DataService, UserService, OperationsService } from '../../_services/index';
import { AuthenticationService, StorageService, AnalyticsService } from '../../_services/index';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { Router } from '@angular/router';  

@Component({
  selector: 'app-repaymentsourcedistribution',
  templateUrl: './repaymentsourcedistribution.component.html',
  styleUrls: ['./repaymentsourcedistribution.component.css']
})
export class RepaymentsourcedistributionComponent implements OnInit {

  public pie_report_subcategories = [
    {
      'display': 'Occupation',
      'value': '1'
    },
    {
      'display': 'Sector',
      'value': '2'
    }
    ,
    {
      'display': 'State of Origin',
      'value': '3'
    },
    {
      'display': 'Marital Status',
      'value': '4'
    },
    {
      'display': 'Gender',
      'value': '5'
    }
    ,
    {
      'display': 'Income',
      'value': '8'
    },
    {
      'display': 'Age',
      'value': '6'
    },
    {
      'display': 'Home Address State',
      'value': '7'
    }
  ];
  public statuses = [
    { value: '1', display: 'Disbursed', has_date: true },
    { value: '2', display: 'Repaid', has_date: true },
    { value: '3', display: 'Late', has_date: false },
    { value: '4', display: 'PAR 30', has_date: false },
    { value: '5', display: 'PAR 60', has_date: false },
    { value: '6', display: 'PAR 90', has_date: false },
  ];
  pie_perf = {
    PIETPDATE: '',
    PIETPDATE_: '',
    CATEGORY: '2',
    SUBCATEGORY: this.pie_report_subcategories[0],
    SUBSTAFFCATEGORY: '',
    LOAN_STATUS: this.statuses[1]
  }
  public doughnutChartLabels: string[] = ['', '', '', '', ''];
  public doughnutChartData: number[] = [0, 0, 0];
  public doughnutChartLegent: any = { 'display': false, 'position': 'bottom' };
  public doughnutChartType: string = 'doughnut';
  public doughnutChartOptions: any = {
    legend: {
      display: false,
      position: 'right'
    },
    percentageInnerCutout :10
  };
  currentUser: any;
  loading = false;
  running_employee_performace: false;
  platform_performance: any;
  customers: any;
  constructor(public analytics: AnalyticsService, public approvalService: ApprovalsService, public DataService: DataService,
    public router: Router, public fb: FormBuilder, public operationsService: OperationsService, public authService: AuthenticationService,
    public storageService: StorageService) {
    this.currentUser = this.storageService.read<any>('currentUser');
  }

  ngOnInit() {
    this.runPiePerformance();
  }

  runPiePerformance() {

    this.loading = true;
    this.analytics.runRepaymentSourceDistribution(this.currentUser.token, this.pie_perf)
      .subscribe(employee_performance => {
        this.loading = false;
        this.running_employee_performace = false;
        this.platform_performance = employee_performance;
        this.doughnutChartLabels = employee_performance.labels;
        this.doughnutChartData = employee_performance.data;
        this.customers = employee_performance.customers;
      });

  }
  // events
  public chartClicked(e: any): void {
    //console.log(e);
  }

  public chartHovered(e: any): void {
    //console.log(e);
  }

}
